import { type RefObject, useEffect } from 'react';

const NO_IDS: string[] = [];

/** Calls `onDismiss` on Escape or on a click outside `ref` and outside the elements with `ignoreIds`. */
export default function useDismiss(
  ref: RefObject<HTMLElement | null>,
  isOpen: boolean,
  onDismiss: () => void,
  ignoreIds: string[] = NO_IDS,
) {
  useEffect(() => {
    if (!isOpen) return undefined;

    const onMouseDown = (event: MouseEvent) => {
      const target = event.target as Node;
      if (ref.current?.contains(target)) return;
      if (ignoreIds.some((id) => document.getElementById(id)?.contains(target))) return;
      onDismiss();
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onDismiss();
    };

    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [ref, isOpen, onDismiss, ignoreIds]);
}
